import { create } from 'zustand';
import type { BannerType } from '@/config/banners';

/**
 * Which global system banners are on screen right now, published by the
 * global `SystemBannerSlot`.
 *
 * Read by the email status toast (YAR-477): no toast while a `gmail_*`
 * banner shows — the banner already carries the fix, and "couldn't be
 * read" next to "Reconnect Gmail" is two messages about one problem.
 */
interface VisibleBannersState {
  globalTypes: readonly BannerType[];
  setGlobalTypes: (types: readonly BannerType[]) => void;
}

export const useVisibleBannersStore = create<VisibleBannersState>()((set) => ({
  globalTypes: [],
  setGlobalTypes: (types) => set({ globalTypes: types }),
}));

/** True while any `gmail_*` banner is visible. */
export function selectGmailBannerVisible(state: VisibleBannersState): boolean {
  return state.globalTypes.some((t) => t.startsWith('gmail_'));
}
